import { Button } from '../../../../../../components/button/button';
import { Card } from '../../../../../../components/card/card';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { Container } from '../../../../../../components/container/container';
import { Label } from '../../../../../../components/label/label';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import { LeadContentType } from '../../../../../../store/api/leads-api';
import { formFields } from '../../helpers';
import s from './lead-form.module.css';
import { useLeadForm } from './use-lead-form';

export const LeadForm = () => {
  const {
    lead,
    handleCheckAvailable,
    handleCheckField,
    handleCheckFieldRequired,
    handleUpdateTitle,
    t,
    handleBack,
  } = useLeadForm();

  return (
    <Card className={s.feature} title={`1. ${t('Настройка')}`} withLang>
      <div className={s.form}>
        <Container label={t('Приветственный текст')} required>
          <LangInput value={lead?.title} onChange={handleUpdateTitle} name="hello" />
        </Container>

        <Label label={t('Выберите необходимые поля')} />
        <ul className={s.list}>
          {formFields.map(({ id, value }) => (
            <li key={id} className={s.item}>
              <Checkbox
                label={t(value)}
                checked={lead?.content?.some((item) => item.type === id)}
                onClick={() => handleCheckField(id as LeadContentType)}
              />
              <Checkbox
                label={t('Обязательное поле')}
                checked={lead?.content?.find((item) => item.type === id)?.is_required}
                onClick={() => handleCheckFieldRequired(id as LeadContentType)}
              />
            </li>
          ))}
        </ul>
        <h4>{t('Настройте отображение')}</h4>
        <Checkbox
          label={t('Отображать форму')}
          checked={lead?.display_setting_type === 'FULL_ON'}
          onClick={handleCheckAvailable}
        />
      </div>
      <Button onClick={handleBack} className={s.button} variant="secondary">
        {t('Назад')}
      </Button>
    </Card>
  );
};
